import { render, staticRenderFns } from "./shopComment.vue?vue&type=template&id=f5725632&scoped=true"
import script from "./shopComment.vue?vue&type=script&lang=js"
export * from "./shopComment.vue?vue&type=script&lang=js"
import style0 from "./shopComment.vue?vue&type=style&index=0&id=f5725632&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5725632",
  null
  
)

export default component.exports